import ITypeUnite from "../../models/ITypeUnite";
import {Button} from "devextreme-react/button";
import React, {Dispatch, SetStateAction, useEffect, useState} from "react";
import useApi from "../../hooks/useApi";
import IUnite from "../../models/IUnite";
import {TypeTabCalendrier} from "../calendrier/calendrier";
import List, {ItemDragging} from "devextreme-react/list";
import {CheckBox} from "devextreme-react/check-box";
import LoadIndicator from "devextreme-react/load-indicator";
import DataGrid, {Column, Editing, Paging, RowDragging, Scrolling, SearchPanel} from "devextreme-react/data-grid";
import {ToolbarItem} from "devextreme-react/popup";
import ILookupItem from "../../models/ILookupItem";


interface IListUniteDisponcibleItemProps {
    typeUnite: ITypeUnite
    dateDebut: Date,
    dateFin: Date
    refresh?: boolean
    setSelectedUnite: Dispatch<SetStateAction<ILookupItem[] | undefined>>
    selectedUnite: ILookupItem[],
    isModeModify?: boolean
}

const ListUniteDisponibleItem = ({typeUnite, dateDebut, dateFin, refresh, selectedUnite, setSelectedUnite, isModeModify}: IListUniteDisponcibleItemProps) => {
    const [collapsed, setCollapsed] = useState(true)

    const {data: unitesDisponibles, getData: getUnitesDisponibles, isLoading} = useApi<ILookupItem[]>("typeunite")

    useEffect(() => {
        if (collapsed || !typeUnite.idTypeUnite || !dateDebut || !dateFin || dateDebut <= new Date(1900, 0, 1) || dateFin <= new Date(1900, 0, 1)) return;
        getUnitesDisponibles({customPath: `typeunite/${typeUnite.idTypeUnite}/unitedisponiblites?typeCalendrier=${TypeTabCalendrier.TypeUnite}&datedebut=${dateDebut.toDateString()}&datefin=${dateFin.toDateString()}`})
    }, [collapsed, refresh, dateDebut, dateFin])

    return (
        <div style={{display: "flex", flexDirection: "column"}}>
            <div className={"list-unite-disponible-item"}>
                <div style={{flex: 1}}>{typeUnite.description}<LoadIndicator style={{marginLeft:'0.5rem'}} visible={isLoading } height={13} width={13} /></div>
                <Button icon={collapsed ? "chevrondown" : "chevronup"}
                        onClick={() => {
                            setCollapsed(prev => !prev)
                        }}
                        style={{boxShadow: "none"}}
                />
            </div>
            {!isLoading && !collapsed &&
                <DataGrid id={`listUnite-${typeUnite?.idTypeUnite}`} noDataText={""}
                          dataSource={unitesDisponibles}
                          searchPanel={{visible: (unitesDisponibles?.length || 0) > 10}}>
                    <SearchPanel/>
                    <Editing mode={"cell"} allowUpdating={true} allowAdding={false} allowDeleting={false}/>
                    {isModeModify && <RowDragging showDragIcons={false} group={"ajoutRapid"} onDragStart={(e: any) => {
                        const unite = [...selectedUnite.filter(f => !f.id.equals(e.itemData.id)), e.itemData]
                        e.itemData = {selectedUnite: unite, dateDebut, dateFin}
                    }}/>}
                    <Column dataField={"selectionnee"} caption={""} width={"1rem"} dataType={"boolean"}
                            calculateCellValue={(e: ILookupItem) => {
                                return !!selectedUnite.find(f => f.id.equals(e.id))
                            }}
                            setCellValue={(e: any, value: boolean, currentRowData: ILookupItem) => {
                                setSelectedUnite(prev => {
                                    const uniteSanscurrent = prev?.filter(p => !p.id.equals(currentRowData.id))
                                    return value ? [...prev || [], currentRowData] : [...uniteSanscurrent || []];
                                });
                                e = value;
                                return e;
                            }}/>
                    <Column alignment={"center"} allowEditing={false} dataField={"description"}/>
                </DataGrid>}
        </div>
    )
}
export default ListUniteDisponibleItem